/* STREETSTYLE homepage category chips — filters an already-rendered grid
   client-side, same interaction as index.html's "New & Popular" filter. */
(function () {
  document.querySelectorAll('[data-npop-grid]').forEach((grid) => {
    const chipsWrap = grid.previousElementSibling;
    if (!chipsWrap || !chipsWrap.classList.contains('npop__chips')) return;
    const cards = [...grid.children];
    chipsWrap.addEventListener('click', (e) => {
      const btn = e.target.closest('.chip');
      if (!btn) return;
      [...chipsWrap.children].forEach((c) => c.setAttribute('aria-pressed', String(c === btn)));
      const cat = btn.dataset.c;
      cards.forEach((card) => { card.hidden = cat && card.dataset.cat !== cat; });
    });
  });
})();
